// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2gLaZ","gfeWrapper":"CalendarEvent_gfeWrapper__3VWzD"};